import { UserIsAuthenticated, UserHasValidPassword, UserHasScope } from 'containers/authContainers'
import LockRedirect from 'containers/lockContainers'
import { browserHistory } from 'utils/navigation'
import { setPageTitle } from 'utils/misc'
import { injectReducers } from 'store/reducers'
import AllSchedulesView from './containers/AllSchedulesContainer'
import { instrumentActions } from '../../modules/Instrument'
import instruments, { fetchInstruments } from '../../../InstrumentsPage/modules/Instruments'
import { fetchCohorts } from '../../../../../Participants/routes/ParticipantsPage/modules/Participants'
import sitesReducer, { fetchSites } from '../../../../../Sites/routes/SitesPage/modules/Sites'
import { fetchVisitTemplates } from '../../../../../Participants/routes/CreateParticipant/modules/CreateParticipant'
import { hasSchedulingEngineFeature } from 'utils/studyConfigUtils'
import { actions as visitScheduleActions } from '../../../../../VisitSchedules/routes/VisitSchedulesPage/modules/VisitSchedules'

export default store => ({
  path: ':instrumentID/schedules',
  getComponent(nextState, cb) {
    const ensure = require.ensure || ((dependencies, callback) => callback())
    ensure(
      [],
      async () => {
        injectReducers(store, {
          sites: sitesReducer,
          instruments,
        })
        const { studyID, instrumentID, studyVersionID } = nextState.params
        const { currentStudy } = store.getState().study
        if (hasSchedulingEngineFeature(currentStudy)) {
          browserHistory.replace(
            `/studies/${studyID}/${studyVersionID}/instruments/${instrumentID}/schedule`,
          )
          cb(null, () => null)
          return
        }
        setPageTitle(`All Schedules | Study ${studyID} | ${currentStudy.platform_name}`)

        await store.dispatch(fetchSites(studyID, true, false, false))
        await store.dispatch(fetchCohorts(studyID, false))

        const existingInstrument = store.getState()?.instrumentReducer?.instrument
        if (!existingInstrument?.id || String(existingInstrument.id) !== String(instrumentID)) {
          await store.dispatch(instrumentActions.onFetchInstrument(studyID, instrumentID))
        }

        const confirmedSchedules = store.getState()?.instrumentReducer?.confirmedSchedules || []
        // All Schedules is only available once at least one schedule has been reviewed/created
        if (!confirmedSchedules.length) {
          browserHistory.replace({
            pathname: `/studies/${studyID}/${studyVersionID}/instruments/${instrumentID}/schedule`,
            state: { keepTriggerDraft: true },
          })
        }

        const existingInstrumentList = store.getState()?.instruments?.instrumentList
        if (!Array.isArray(existingInstrumentList) || existingInstrumentList.length === 0) {
          store.dispatch(fetchInstruments({ studyID, hasLoader: false }))
        }

        const hasVisitSupport = !!currentStudy?.config?.visit_support
        if (hasVisitSupport) {
          const isVisitCycleSupported = currentStudy?.config?.visit_support?.version > 1
          const existingVisitTemplates = store.getState()?.participantReducer?.visitTemplates
          const existingStudyVisitSchedule = store.getState()?.visitSchedules?.studyVisitSchedule

          const visitFetches = []
          if (!Array.isArray(existingVisitTemplates) || existingVisitTemplates.length === 0) {
            visitFetches.push(store.dispatch(fetchVisitTemplates(studyID)))
          }
          if (
            isVisitCycleSupported &&
            (!Array.isArray(existingStudyVisitSchedule) || existingStudyVisitSchedule.length === 0)
          ) {
            visitFetches.push(store.dispatch(visitScheduleActions.fetchVisitSchedules(studyID)))
          }
          if (visitFetches.length) {
            await Promise.all(visitFetches)
          }
        }

        cb(
          null,
          UserIsAuthenticated(
            UserHasValidPassword(
              LockRedirect(studyID, studyVersionID, 'instruments')(
                UserHasScope(['wa'], AllSchedulesView, false, studyID),
              ),
            ),
          ),
        )
      },
      'instruments/schedules',
    )
  },
})
